/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: block;
  cursor: pointer;
  padding: 0 calc(16rem/14) 0 calc(10rem/14);
  line-height: calc(36rem/14);
  min-height: calc(36rem/14);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  border-left: 6px solid transparent;
}

:host([selected=true]) {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
  border-color: var(--davinci-color-primary,#007CC1);
}

:host([disabled]) ::slotted(*),
:host([disabled]) {
  pointer-events: none;
  cursor: default;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host,
* {
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}`;
export { style };
